import { stringify } from 'query-string';

import { IQueryParams } from 'typescriptDefs';

const urlWebOnboarding = `https://web.${
  process.env.GATSBY_ENVIRONMENT === 'production' ? '' : 'sandbox-'
}koho.ca/registration`;

const urlsOnboarding = {
  web: urlWebOnboarding,
};

const getQueryString = (queryParams: IQueryParams): string => {
  let stringHash = '',
    stringSearch = '';

  const queryParamsHashStringified = stringify(queryParams.hash);
  const queryParamsSearchStringified = stringify(queryParams.search);

  if (queryParamsHashStringified) {
    stringHash = `#${queryParamsHashStringified}`;
  }

  if (queryParamsSearchStringified) {
    stringSearch = `?${queryParamsSearchStringified}`;
  }

  return `${stringSearch}${stringHash}`;
};

export const getWebOnboardingLink = (queryParams: IQueryParams): string => {
  const queryString = getQueryString(queryParams);
  return `${urlsOnboarding.web}${queryString}`;
};

export const getAppOnboardingLink = (queryParams: IQueryParams, oneLinkURL: string) => {
  const oneLinkQueryString = getQueryString(queryParams);
  return `${oneLinkURL}${oneLinkQueryString}`;
};
